import React, { useState } from 'react';
import Button from 'view/common/elements/button';
import Link from 'view/common/elements/link';
import OutlineButton from 'view/common/elements/outlineButton';
import Upload from 'view/common/elements/upload';

const AllImages = (props) => {
  const [showUpload, setShowUpload] = useState(false);
  const [canUploadFile, setCanUploadFile] = useState(false);
  const [uploadButtonDisabled, setUploadButtonDisabled] = useState(true);

  const onFileUploadComplete = ()  => {
    setCanUploadFile(false);
    setShowUpload(false);
    setUploadButtonDisabled(true)
  }
  const onFileUploadError = () => {
    setUploadButtonDisabled(false)
  }
  const onFileSelected = () => {
    setUploadButtonDisabled(false)
  }
  return ( 
    <div>
      {
        showUpload &&
        <div>
          <Upload
            accept={["jpeg","jpg","png"]}
            canUploadFile={canUploadFile}
            onUploadSuccess={onFileUploadComplete}
            onUploadError={onFileUploadError}
            onFileSelect={onFileSelected}
          />
          <Button
            text={`Upload`}
            onClick={() => setCanUploadFile(true)}
            className={`mt-2`}
            disabled={uploadButtonDisabled}
          />
          <OutlineButton
            text={`Cancel`}
            onClick={() => setShowUpload(false)}
            className={`ml-2 mt-2`}
          />
        </div>
      }
      
      {!showUpload && 
        <Link
          text={`+ Add Images`}
          onClick={() => setShowUpload(true)}
        />
      }
      
    </div>
  ) 
}

export default AllImages;